import { LinearProgress as MuiLinearProgress } from '@mui/material';
import type { LinearProgressProps as MuiLinearProgressProps } from '@mui/material/LinearProgress';

export type LinearProgressProps = MuiLinearProgressProps;

export const LinearProgress = ({ ...rest }: LinearProgressProps): JSX.Element => (
  <MuiLinearProgress {...rest} />
);
